import OAuth2Service from './OAuth2Service';
import has from 'lodash/has';

function authenticate(fn, credInfo) {
  const clientId = credInfo['sharepoint.client_id'];
  const clientSecret = credInfo['sharepoint.client_secret'];
  const tenantId = credInfo['tenant_id']; //'common'; //'114b0563-b3a6-4d9e-93b9-398116848e97';
  const oauth2Params = {
    'oauth2.auth_url': `https://login.microsoftonline.com/${tenantId}/oauth2/v2.0/authorize`,
    'oauth2.auth_url_param.client_id': clientId,
    'oauth2.auth_url_param.scope': 'https://graph.microsoft.com/.default',
    'oauth2.auth_url_param.response_type': 'code',
    'oauth2.auth_url_param.prompt': 'login',
    'oauth2.token_url': `https://login.microsoftonline.com/${tenantId}/oauth2/v2.0/token`,
    'oauth2.token_url_param.client_id': clientId,
    'oauth2.token_url_param.client_secret': clientSecret,
    'oauth2.token_url_param.grant_type': 'authorization_code',
    'oauth2.token_url_param.scope': 'https://graph.microsoft.com/.default offline_access',
  };
  const credStaticInfo = {
    'auth.type': 'OAUTH2',
    'oauth2.client.id': clientId,
    'oauth2.client.secret': clientSecret,
    'oauth2.token.type.override': 'Bearer',
    'oauth2.access.token.method': 'POST',
    'oauth2.access.token.url': `https://login.microsoftonline.com/${tenantId}/oauth2/v2.0/token`,
    'vendor.refresh_url': `https://login.microsoftonline.com/${tenantId}/oauth2/v2.0/token`,
    'vendor.auth_scheme': 'header',
  };

  return OAuth2Service.authenticate((authInfo, error) => {
    if (authInfo && has(authInfo, 'access_token')) {
      fn({ ...credStaticInfo, ...authInfo }, null);
    } else {
      fn(null, error);
    }
  }, oauth2Params);
}

export default {
  authenticate,
};
